import React from 'react';
import { connect } from 'react-redux';
import Logger, { LOG_LEVELS } from '../../../utils/logger';


const log = new Logger('YEAR_SELECTOR', LOG_LEVELS.DEBUG);

export class YearSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentYear: new Date().getFullYear()
    };
  }

  selectionHandler(event) {
      log.debug('selectionHandler(): ', event);
      log.debug('selectionHandler(): target.value', event.target.value);
      this.props.selectionHandler({year: event.target.value})
  }

  render() {
    log.debug('render(): ', this.props);
    return (
      <input data-testid="year-selector" type="number" name="year" value={parseInt(this.props.year)} min="1900" max={this.state.currentYear} onChange={this.selectionHandler.bind(this)} {...this.props.extraProps}/>      
      )
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


// Wrap the component to inject state into it
export default connect(mapStateToProps)(YearSelector);